<template>
    <main>
         <div>
            <div class="card text-center" style="padding: 10px 5% 10px; min-height:200px" >
                <div>
                    Buscar zonas vulnerables donde estuviste en contacto
                </div>
                <div class="card-body" style="margin:auto;" >
                          
                   <div class="J-canvas-container" v-if="active">
                        <div class="J-loader-count" :class="countClass">
                            <button class='J-btn J-btn-scanning' @click="getSearch()" v-if='!isScanning'><i class="fas fa-search"></i></button>
                            <span v-else>
                                <span>{{count}}</span>
                                <span class="J-loader-percentage">%</span>
                            </span>
                        </div>       
                        <!--<canvas id="canvasFlare" style="width: 503px; height: 343px;"></canvas>-->
                   </div>
                   <div>
                       <span class="J-message-danger">
                           Está opcion todavia no esta habilitado, pronto estará disponible.
                       </span>
                   </div>

                </div>
                <div>
                </div>
            </div>
         </div>
    </main>
</template>
<script>
import {TweenMax,Circ} from "gsap";

//import FlareAnimation from '@/utils/flareAnimation';

    import { EventBus } from '@/helpers/eventbus/event-bus'
    
    export default {
        data(){
            return{
                count:0,
                active:false,
                countClass:"active30",
                //flareExample:null,
                valFinish:0,
                tween:null,
                isScanning:false
            }
        },
        mounted(){
            //this.loadFlare();
        },
        methods:{
            help:function(){
                this.$emit('close')
                //EventBus.$emit('alert','help')

            },
            /*loadFlare(){
                /*this.flareExample = new FlareAnimation(document.getElementById("canvasFlare"),503, 343,()=>{
                    this.flareExample.load("./gootwork animation (18).flr", function (error) {
                        if (error) {
                            console.log("failed to load actor file...", error);
                        }
                    });
                    this.flareExample.setSize(503, 343);
                });

                //this.flareExample.animate("60")
            },*/
            getSearch(){
                var progressData;
                let _this=this;
                _this.isScanning=!_this.isScanning;
                let config = {
                    onUploadProgress: (progressEvent) => {
                        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                        if (totalLength !== null) {
                            progressData = Math.round( (progressEvent.loaded * 100) / totalLength );
                            console.log("onUploadProgress", progressData);

                        }
                    },
                    onDownloadProgress: (progressEvent) => {

                        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                        if (totalLength !== null) {
                            
                            progressData = Math.round( (progressEvent.loaded * 100) / totalLength );
                            setTimeout(()=>{
                                console.log(_this.tween)
                                _this.tween.kill();
                                _this.loadCount(_this.valFinish,progressData)
                            },1000)
                            console.log("onDownloadProgress", progressData);
                        }
                    },
                }
                this.loadCount(0,30);
                axios.get('scanning/location',  config).then(response => console.log(response));
            },
            loadCount(valInit=0,valFinish=0){
                
                var counter = { var: valInit };
                let _this=this;
                _this.valFinish=valFinish; 
                count()
                function count(){
                    _this.tween=TweenMax.to(counter,2, {
                        var: valFinish, 
                        onUpdate: function () {
                            var number = Math.ceil(counter.var);
                                _this.count=number
                                var i=number;
                                switch(i){
                                    case 0:
                                        _this.countClass='active30'
                                        break;
                                    case 30:
                                        //_this.flareExample.animate("60")
                                        _this.countClass='active60'
                                        break;
                                    case 60:
                                        //_this.flareExample.animate("90")
                                        _this.countClass='active90'
                                        break;
                                }
                                if(number === counter.var){  _this.tween.kill(); }
                            },
                            onComplete: function(){
                            count();
                        },    
                        ease:Circ.easeOut
                    });
                }
            },
            symptomsHelp:function(){
                this.$emit('close')
                //EventBus.$emit('alert','symptoms-help')
            },
            searchHelp:function(){
                this.$emit('close')
                //EventBus.$emit('alert','search-help')
            }
        }

    }
</script>